import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
// 系统通用样式
import '@/assets/styles/common.css';
Vue.use(iView);
Vue.use(Vuex);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ElementUI);
// vuex,
import store from './store'
Vue.prototype.$screenWidth = window.innerWidth;
window.addEventListener('resize', () => {
  Vue.prototype.$screenWidth = window.innerWidth;
});
Vue.prototype.$screenHeight = window.innerHeight;
window.addEventListener('resize', () => {
  Vue.prototype.$screenHeight = window.innerHeight;
});

import VueRouter from 'vue-router';
Vue.use(VueRouter);

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer);

Vue.config.silent = true;
Vue.config.productionTip = false
import router from './router';
import { mapState } from 'vuex';
 // 动态加载配置
const loadConfig = () => {
  return new Promise((resolve) => {
    if (window.applicationConfig) {
      resolve(); // 已加载则直接继续
      return;
    }
    const script = document.createElement('script');
    script.src = '/config/basicConfig.js';
    script.onload = resolve;
    document.head.appendChild(script);
  });
};
// 2. 异步初始化 Vue 应用
const initVueApp = async () => {
  // 先等待配置加载完成
  await loadConfig();

  // 配置加载完成后，再创建 Vue 实例
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
};

// 3. 启动应用
initVueApp();


